import { FeatureStatusChangedMessage, GameUIMessageType } from 'game-ui-types'
import { useConfigurationStore } from '@stores'
import useMessageData from './useMessage'

const useFeatureLayout = () => {
    const setIsFeatureRunning = useConfigurationStore((state) => state.setIsFeatureRunning)

    useMessageData(
        (data) => {
            if (data?.type !== GameUIMessageType.FEATURE_STATUS_CHANGED) return

            const { status, name } = (data as FeatureStatusChangedMessage).payload

            const notableFeatures = ['freespins', 'holdAndSpin']

            if (status === 'started' && notableFeatures.includes(name)) setIsFeatureRunning(true)

            if (status === 'completed' && notableFeatures.includes(name)) setIsFeatureRunning(false)
        },
        [setIsFeatureRunning]
    )
}

export default useFeatureLayout
